import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType'; // import calendar from '@/components/Echart/calendar'

import calendarPie from '@/components/env-bigData/calendarPie';
import calendar from '@/components/env-bigData/calendar';
import monthSelect from '@/components/date/bmonthSelect'; //天然气压

import realData from '@/components/env-bigData/realData'; //站点报警

import systemWarning from '@/components/env-bigData/systemWarning'; //气压差，节能减排图表

import conserve from '@/components/env-bigData/conserve';
import { getAction } from '@/api/manage';
import { queryWastDateList, queryWastegasCurveAnalysis, querWastegasReport, standardWasteSkyMonth, queryWastegasStand } from '@/api/api';
export default {
  data: function data() {
    return {
      DataSum: {},
      standState: false,
      standLabel: '',
      dateList: [],
      showRadio: true,
      firstPollution: {},
      showCalendar: true,
      showDetail: false,
      defaultValue: 1,
      showAnalysis: false,
      showToast: false,
      toastText: '',
      analysisType: 11,
      title: [],
      colors: ['#ccc'],
      showDial: false,
      defaultValues: 0,
      radioStatu: true,
      defaultValue2: 1
    };
  },
  components: {
    conserve: conserve,
    realData: realData,
    systemWarning: systemWarning,
    border: border,
    calendar: calendar,
    monthSelect: monthSelect,
    calendarPie: calendarPie
  },
  created: function created() {// this.getStandard()
  },
  mounted: function mounted() {
    var _this = this;

    // setInterval(this.scroll, 1000)
    //自适应
    this.initData();
    this.timer = setInterval(function () {
      _this.initData();
    }, 180000);
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {// selectId(val) {
    //   this.$nextTick(() => {
    //     this.$nextTick(() => {
    //       this.defaultValues = 1
    //       this.analysisType = 11
    //       // this.getStandard(val)
    //       this.getReport(val)
    //       this.getAirnow(val)
    //       this.getPolutionData(val)
    //       this.getWarn(this.defaultValues, val, this.selectType)
    //       this.getwaterStand(val)
    //       // this.getSkyList(val)
    //     })
    //   })
    // },
  },
  methods: {
    // 获取所有数据
    initData: function initData() {
      this.getPolutionData('1');
      this.getPolutionData('2');
      this.getDataSum();
    },
    //获取数据汇总
    getDataSum: function getDataSum() {
      var _this2 = this;

      // 请求数据
      getAction('/online/st54/summary/259').then(function (res) {
        if (res.success) {
          console.log('res.....', res);
          _this2.DataSum = res.result;
        }
      });
    },
    // 气压的tab切换
    changeRadio2: function changeRadio2(e) {
      var time;

      switch (e.target.value) {
        // analysisType用于控制查询的水质趋势的类型  11:小时数据  12:日数据
        case 1:
          this.analysisType2 = 11;
          this.getPolutionData('2', this.getDay(0));
          break;

        case 2:
          this.analysisType2 = 12;
          this.getPolutionData('2', this.getDay(7));
          break;

        case 3:
          this.analysisType2 = 12;
          this.getPolutionData('2', this.getDay(30));
          break;
      }
    },
    // 获取水质趋势
    getPolutionData: function getPolutionData(type, start) {
      var _this3 = this;

      if (!start) start = this.getDay(0);
      queryEnergyAnalysis({
        scopeId: this.siteId,
        type: type == '1' ? this.defaultValue : this.defaultValue2,
        stime: start,
        etime: this.getDay(0),
        dataType: type == '1' ? this.analysisType : this.analysisType2
      }).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var obj = {};
            var popArr = [];
            var arr = [];
            var time = [];
            var labelData = [];
            var seriesData = {};

            if (type == 1) {
              res.result.query.factors.forEach(function (ele) {
                if (ele.code == 'p05012' || ele.code == 'p05013') {
                  labelData.push(ele.title);
                  res.result.records.forEach(function (element) {
                    if (element.factor[ele.code]) {
                      obj.name = element.dateStr;
                      obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                      arr.push(obj);
                      obj = {};
                    }
                  });
                }

                seriesData.data = arr;
                seriesData.title = ele.title;
                popArr.push(seriesData);
                seriesData = {};
                arr = [];
              });
              res.result.records.forEach(function (data) {
                time.push(data.dataTime);
              });
            } else {
              res.result.query.factors.forEach(function (ele) {
                if (ele.code == 'p04000') {
                  res.result.records.forEach(function (element) {
                    if (element.factor[ele.code]) {
                      obj.name = element.dateStr;
                      obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0;
                      arr.push(obj);
                      obj = {};
                    }
                  });
                }

                seriesData.data = arr;
                seriesData.title = ele.title;
                popArr.push(seriesData);
                seriesData = {};
                arr = [];
              });
              res.result.records.forEach(function (data) {
                time.push(data.dataTime);
              });
            }

            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;
              setTimeout(function () {
                type == '1' ? _this3.$refs.conserve.initBarChart(popArr, time, labelData) : _this3.$refs.conserve2.initBarChart(popArr, time, labelData);
              }, 100);
            });
          } else {
            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;
              setTimeout(function () {
                type == '1' ? _this3.$refs.conserve.initBarChart([], [], []) : _this3.$refs.conserve2.initBarChart([], [], []);
              }, 100);
            });
          }
        }
      });
    },
    // getwaterStand(scopeId) {
    //   queryWastegasStand({
    //     scopeId,
    //     scope: 1,
    //   }).then((res) => {
    //     if (res.success && res.result) {
    //       let color = []
    //       let title = []
    //       let a = []
    //       let colors = ['green', 'red']
    //       let date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]]
    //       // date.push(Object.keys(res.result['同比标准'])[0])
    //       // date.push(Object.keys(res.result['实时标准'])[0])
    //       // date.push(Object.keys(res.result['环比标准'])[0])
    //       if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
    //         if (res.result[date[0]].upStandard == true) {
    //           color.push(colors[0])
    //           title.push('达标')
    //           a.push(1)
    //         } else {
    //           color.push(colors[1])
    //           title.push('不达标')
    //           a.push(2)
    //         }
    //       } else {
    //         color.push('')
    //         title.push('')
    //         a.push(0)
    //       }
    //       if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
    //         if (res.result[date[1]].upStandard == true) {
    //           color.push(colors[0])
    //           title.push('达标')
    //           a.push(1)
    //         } else {
    //           color.push(colors[1])
    //           title.push('不达标')
    //           a.push(2)
    //         }
    //       } else {
    //         color.push('')
    //         title.push('')
    //         a.push(0)
    //       }
    //       if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
    //         if (res.result[date[2]].upStandard == true) {
    //           color.push(colors[0])
    //           title.push('达标')
    //           a.push(1)
    //         } else {
    //           color.push(colors[1])
    //           title.push('不达标')
    //           a.push(2)
    //         }
    //       } else {
    //         color.push('')
    //         title.push('')
    //         a.push(0)
    //       }
    //       this.showDial = true
    //       this.$nextTick(() => {
    //         this.$refs.dials.initBarChart(title, color, date, a, 2)
    //       })
    //       // let arr = []
    //       // let color = []
    //       // if(res.result['同比标准']){
    //       // 	color.push()
    //       // }
    //       // color.push()
    //     } else {
    //       this.showDial = true
    //       let date = new Date()
    //       let year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    //       let year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    //       let year3 =
    //         date.getMonth() != 0
    //           ? date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate()
    //           : date.getFullYear() - 1 + '-12' + '-' + date.getDate()
    //       this.$nextTick(() => {
    //         this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 2)
    //       })
    //     }
    //   })
    // },
    // 获取排放趋势数据
    // getPolutionData(id, start) {
    //   if (id) this.siteId = id
    //   if (!start) start = this.getDay(0)
    //   queryWastegasCurveAnalysis({
    //     scopeId: this.siteId,
    //     dataType: this.analysisType,
    //     stime: start,
    //     type: 1,
    //     etime: this.getDay(0),
    //   }).then((res) => {
    //     if (res.success) {
    //       if (res.result.records.length > 0) {
    //         let obj = {}
    //         let popArr = []
    //         let arr = []
    //         let time = []
    //         let labelData = []
    //         let seriesData = {}
    //         res.result.query.factors.forEach((ele) => {
    //           labelData.push(ele.title)
    //           res.result.records.forEach((element) => {
    //             if (element.factor[ele.code]) {
    //               obj.name = element.dateStr
    //               obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value : 0
    //               arr.push(obj)
    //               obj = {}
    //             }
    //           })
    //           seriesData.data = arr
    //           seriesData.title = ele.title
    //           popArr.push(seriesData)
    //           seriesData = {}
    //           arr = []
    //         })
    //         res.result.records.forEach((data) => {
    //           time.push(data.dataTime)
    //         })
    //         this.showAnalysis = false
    //         this.$nextTick(() => {
    //           this.showAnalysis = true
    //           setTimeout(() => {
    //             this.$refs.pollution.initBarChart(popArr, time, labelData)
    //           }, 100)
    //         })
    //       } else {
    //         this.showAnalysis = false
    //         this.$nextTick(() => {
    //           this.showAnalysis = true
    //           setTimeout(() => {
    //             this.$refs.pollution.initBarChart([], [], [])
    //           }, 100)
    //         })
    //       }
    //     }
    //   })
    // },
    // ontoGet(value, year) {
    //   console.log(value, year)
    //   this.resetSetItem('siteId', this.selectId)
    //   this.resetSetLocalItem('treeSt', '31')
    //   // window.localStorage.setItem('treeSt','21')
    //   this.resetSetItem('siteType', '31')
    //   setTimeout(() => {
    //     this.$router.push({
    //       path: '/online/cn2061',
    //       query: {
    //         year,
    //       },
    //     })
    //   }, 500)
    // if (value) this.toastText = value
    // else this.toastText = '暂无数据'
    // this.showToast = true
    // setTimeout(() => {
    // 	this.showToast = false
    // }, 2000)
    // },
    // 点击aqi  tab的切换
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    } // 获取日期
    // getDay(day) {
    //   let today = new Date()
    //   var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day
    //   today.setTime(targetday_milliseconds) //注意，这行是关键代码
    //   var tYear = today.getFullYear()
    //   var tMonth = today.getMonth()
    //   var tDate = today.getDate()
    //   let hour = today.getHours()
    //   let minute = today.getMinutes()
    //   let second = today.getSeconds()
    //   tMonth = this.doHandleMonth(tMonth + 1)
    //   tDate = this.doHandleMonth(tDate)
    //   return tYear + '-' + tMonth + '-' + tDate
    //   // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    // },
    // doHandleMonth(month) {
    //   var m = month
    //   if (month.toString().length == 1) {
    //     m = '0' + month
    //   }
    //   return m
    // },
    // scroll() {
    //   setTimeout(() => {
    //     if (this.waterWarnList.length > 6) {
    //       this.waterWarnList.push(this.waterWarnList[0]) // 将数组的第一个元素添加到数组的
    //       this.waterWarnList.shift() //删除数组的第一个元素
    //     }
    //     if (this.dateList.length > 5) {
    //       this.dateList.push(this.dateList[0]) // 将数组的第一个元素添加到数组的
    //       this.dateList.shift() //删除数组的第一个元素
    //     }
    //   }, 500)
    // },

  }
};